export function ImgWrapper({ src }) {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <img alt="Service Img" src={src} />
    </div>
  );
}
